import(/* webpackMode: "eager" */ "C:\\Users\\nahus\\Desktop\\Xfactor\\xfactor-frontend\\src\\app\\not-found.tsx");
